/**
 * The shared class tokens of `src/ward/`: class strings that several parts and pages apply, so each
 * look has one definition. Each export is a plain string for `className` or `cn()`.
 */

/**
 * The inert look of a control that keeps its Tab stop while a write or a read runs (`aria-disabled`).
 * It dims the control and shows the not-allowed cursor. The control still takes pointer events, so
 * the cursor shows; its own handler must ignore a press.
 */
export const ARIA_DISABLED_CLASS = 'aria-disabled:cursor-not-allowed aria-disabled:opacity-50';

/**
 * The micro-label over a fact or a field: small semibold capitals with wide tracking, in the muted
 * foreground. Pages put it on a `dt` or a `span` that names the value beside it.
 */
export const MICRO_LABEL_CLASS = 'text-2xs font-semibold uppercase tracking-wider text-muted-foreground';

/**
 * The look of a field that shows a value the operator cannot edit (`readOnly`): the muted fill and
 * the muted text, with the plain cursor. The text keeps its full opacity, so it keeps its contrast.
 */
export const READ_ONLY_CLASS = 'read-only:cursor-default read-only:bg-muted read-only:text-muted-foreground';
